jQuery(function($) {

	const MINAGEFORSTUDENT = 4;
	const MAXAGEFORSTUDENT = 120;

	function ddlbWelkeCursusChange() {
		// Check the chosen value
		// if "anders" - show this field, hide otherwise
		const gekozen = $(this).val();
		if (gekozen === '9999') {
			$("#welkecursus_anders").show();
		} else {
			// prevent submitting this field by clearing the field as well
			$("#welkecursus_anders").val('').hide();
		}
	}

	function ddlbWanneerChange() {
		// Check the chosen value
		// if "anders" - show this field, hide otherwise
		const gekozen = $(this).val();
		if (gekozen === 'Anders, namelijk:') {
			$("#form-field-vanafwanneer_anders").show(); // elementor
			$("#vanafwanneer_anders").show(); // cf7
		} else {
			// prevent submitting this field by clearing the field as well
			$("#form-field-vanafwanneer_anders").val('').hide(); // elementor
			$("#vanafwanneer_anders").val('').hide(); // cf7
		}
	}

	let birthDateIsValid
	function birthdateShowText() {
		// assemble fields that make up the birthdate
		let bdateDay = $("#bdate-day").val();
		let bdateMonth = $("#bdate-month").val();
		const bdateYear = $("#bdate-year").val();
		if (bdateDay != null) {
			bdateDay = bdateDay.length < 2 ? `0${bdateDay}` : bdateDay;
			bdateMonth = bdateMonth.length < 2 ? `0${bdateMonth}` : bdateMonth;

			// check if it's a complete and valid date, only then translate to a text
			const bdate = `${bdateYear}-${bdateMonth}-${bdateDay}`;
			const dObj = new Date(bdate);
			if (bdate.length === 10) {
				const bdInText = dObj.toLocaleDateString('nl-NL', {
					year: 'numeric',
					month: 'long',
					day: 'numeric'
				});
				const age = Math.floor((new Date() - new Date(bdate).getTime()) / 3.15576e+10);
				// remove any previous text
				$("#bdInText").remove();
				$("#geboortedatuminput")
					.after(`<em id="bdInText"><br>&nbsp;${bdInText} (${age})</em>`)
					.after(`<input type="hidden" id='bdate2send' name="geboortedatum" value="${bdate}">`);

				birthDateIsValid = true;
				toggleFormValid(true, "");
			} else {
				$("#bdInText").remove();
				$("#bdate2send").remove();
				if (dObj.getFullYear() > 100) {
					$("#geboortedatuminput")
						.after('<em id="bdInText" class="wpcf7-not-valid-tip"><br>&nbsp;Dit is geen geldige datum</em>')
				}
				birthDateIsValid = false;
				toggleFormValid(false, "Geen geldige geboortedatum");
			}
		}
	}

	function toggleFormValid(setValid=true, message='') {
		$("#sumbitmessage").remove();
		if (setValid) {
			$(".wpcf7-submit")
				.removeAttr("disabled")
				.after(`<span id="sumbitmessage">&nbsp;${message}</span>`);
		} else {
			$(".wpcf7-submit")
				.attr("disabled", true)
				.after(`<span id="sumbitmessage">&nbsp;${message}</span>`);
		}
	}

	// initialize
	$("#bdate-year")
		.prop("max", new Date().getFullYear() - MINAGEFORSTUDENT)
		.prop("min", new Date().getFullYear() - MAXAGEFORSTUDENT);
	$("[id^='bdate']").on("keyup", birthdateShowText);

	$("#welkecursusddlb").on("change", ddlbWelkeCursusChange);
	$("#vanafwanneerddlb").on("change", ddlbWanneerChange);
	$("#form-field-vanafwanneerddlb").on("change", ddlbWanneerChange);
	birthdateShowText();
	$("#welkecursusddlb").each(ddlbWelkeCursusChange);
	$("#vanafwanneerddlb, #form-field-vanafwanneerddlb").each(ddlbWanneerChange);
});